import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./CustomModal.css";

const RejectProductModal = ({ show, handleClose, handleConfirm }) => {
  const [reason, setReason] = useState("");
  const [showValidation, setShowValidation] = useState(false);

  const onInternalSubmit = () => {
    
    if (reason.trim() === "") {
      setShowValidation(true);
    } else {
      setShowValidation(false);
      handleConfirm(reason); 
      setReason(""); 
      handleClose();
    }
  };

  return (
    <Modal className="custom-modal" centered show={show} onHide={handleClose}>
      <a className="close" onClick={handleClose}>×</a>
      <Modal.Body>
        <h3 className="title mb-3" style={{ fontSize: "15px" }}>Reject Reason:</h3>
        <input
          type="text"
          className="add_pro_form_card_input p-1"
          placeholder="Enter reject reason...."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
        {showValidation && <p className="text-center error-text">Please enter a valid reason</p>}
        <div className="">
          <Button
            variant="primary"
            className="reject-product-but flex-center mx-auto mt-3"
            onClick={onInternalSubmit} // Call the new function
          >
            Submit
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RejectProductModal;
